import { render, staticRenderFns } from "./Postnatales.vue?vue&type=template&id=d57f43d8"
import script from "./Postnatales.vue?vue&type=script&lang=js"
export * from "./Postnatales.vue?vue&type=script&lang=js"
import style0 from "./Postnatales.vue?vue&type=style&index=0&id=d57f43d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports